import * as angular from "angular";

const events = {
  forms: {
    phoneChanged: 'phone-number-form-field-models-change',
    fieldsetToggle: 'fieldset-activation'
  }
};

angular
  .module('bringoz.admin.commons')
  .constant('systemEventsConfig', events);
